import * as routeName from '../../routes/routeName';

// Set to false to restore the old delivery-list dropdown behavior.
export const OPEN_DELIVERY_PATIENT_ON_SIGN_PAGE = true;

export const openDeliveryPatientOnSignPage = (navigate, patient) => {
	if (!OPEN_DELIVERY_PATIENT_ON_SIGN_PAGE || !patient?.id || typeof navigate !== 'function') {
		return false;
	}

	navigate({
		pathname: routeName.search_patient_data,
		search: `?id=${patient.id}`,
	});
	return true;
};
